<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
          <el-menu
            class="el-menu-vertical-demo">
            <el-menu-item v-for="item of categoryList" :index="item.id"  @click="handlerCategory(item.id)">
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
          </el-menu>

      </el-col>
      <el-col :span="18">
        <!-- 公司简介 -->
        <div class="cpy_info">
          <div class="result-item" v-if="contentData.length>0 " v-for="item in contentData">
            <img class="image" :src="globalUrl.resourceUrl+item.photoUrl" @click="clickToRouter(item.id)"></img>
            <span class="title">
              <el-tooltip effect="dark" :content="item.title" placement="top-start">
                <router-link class="show-ellipsis" :to="{path:'/cpyResultContent?contentId='+item.id}">{{item.title}}</router-link>
              </el-tooltip>
            </span>
          </div>
          <el-pagination @current-change="initData" :current-page.sync="currentPage" :page-size="pageSize" :total="totalData" layout="total, prev, pager, next"></el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
    data: function() {
        return {
          categoryList:[],
          contentData:[],

          currentCategoryId:this.$route.query.categoryId || 0,
          currentPage: 1,
          pageSize: 9,
          totalData: 0,
        }
    },
    created: function() {
      this.getCategory();
      this.initData();
    },
    methods: {
      initData(){
        console.log(this.currentCategoryId);
        var self = this;
        var postData = {
            "pageSize": this.pageSize,
            "pageNo": this.currentPage,
            "params": {"categoryId":this.currentCategoryId},
        }

        this.$http.post(self.globalUrl.cpyResultPage, JSON.stringify(postData)).then(function(res) {
            if (res.data.code == 200000) {
                self.contentData = res.data.data.records;
                self.totalData = Number(res.data.data.total);
            }
        });

      },
      getCategory(){
        var self = this;
        this.$http.get(self.globalUrl.cpyResultCategoryList).then(function(res) {
            if (res.data.code == 200000) {
                self.categoryList = res.data.data;
            }
        });
      },
      handlerCategory(id){
          this.currentCategoryId = id;
          this.initData();
      },
      clickToRouter(id){
        this.$router.push('/cpyResultContent?contentId='+id);
      }

    }
}
</script>
<style media="screen" lang="less">

.cpy_info{
  margin-top: 2px;

  &>.result-item{
    margin: 30px 30px 4px 4px;
    border: 1px solid #fff;
    width: 250px;
    height: 200px;
    max-width: 250px;
    max-height: 200px;
    display: inline-block;

    &>.image{
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 100%;

    }

    &>.title{
       position: relative;
       display: block;
       box-sizing: border-box;
       background-color: #d4d4d4;
       opacity:0.5;
       text-align: center;
       width: 100%;
       overflow: hidden;
       white-space: nowrap;
       text-overflow: ellipsis;
    }
  }
}

.article{
  margin-top: 2px;
  height: 300px;

  &>ul.article-list{

    &>li{

      &>a.router-link-active{
          color   : #fff;
          background-color: #ff8a23;
      }
    }
  }
}




</style>



// WEBPACK FOOTER //
// cpyResultList.vue?1b744326